import { search_for_item_id, get_all_locales, get_title_from_id, IDSearch, get_all_providers } from "./justwatchapi";
export async function search(query, locale) {
    return await search_for_item_id(query, locale);
}
export class TVOrMovie extends IDSearch {
    constructor(is, short_description, number_seasons, backdrop_url, offers) {
        super(is.title, is.id, is.poster_uri, is.type, is.release_year, is.query_locale);
        this.short_description = short_description;
        this.number_seasons = number_seasons;
        this.backdrop_url = backdrop_url;
        this.offers = offers;
    }
}
class CountryOffers {
    constructor(country, offers) {
        this.country = country;
        this.offers = offers;
    }
}
class Offer {
}
export async function get_all_info_from_id(search, providers) {
    const locales = await get_all_locales();
    let country_info = [];
    var append_country_info = locales.map(async (i) => {
        let r = await get_title_from_id(search.id, i.full_locale, search.type);
        country_info.push({ country: i.country, info: r });
    });
    await Promise.all(append_country_info);
    let home = country_info.filter((obj) => {
        return obj.country === search.query_locale.country;
    });
    home = home[0].info;
    let short_description = home["short_description"];
    // Gets the backdrop url.
    let regex = new RegExp("\\s*([0-9]+)");
    let regex_match = regex.exec(home["backdrops"][0]["backdrop_url"]);
    let backdrop_url = (regex_match != null) ? `https://images.justwatch.com/backdrop/${regex_match[0]}/s1920/backdrop.webp` : "NULL";
    let seasons = ("seasons" in home) ? home["seasons"] : "NULL";
    let offers = [];
    var append_offers = country_info.map(async (i) => {
        let country = i.country;
        i = i.info;
        if ("offers" in i) {
            let os = [];
            var append_os = i["offers"].map(async (i) => {
                if (i["monitization_types"] == "flatrate" || "ads" || "free") {
                    providers.forEach(provider => {
                        if (i.provider_id == provider.id) {
                            os.push({
                                id: provider.id,
                                short_name: provider.short_name,
                                clear_name: provider.clear_name,
                                icon_uri: provider.icon_uri,
                                monetization_types: provider.monetization_types,
                                url: i["urls"]["standard_web"]
                            });
                        }
                    });
                }
            });
            await Promise.all(append_os);
            offers.push({
                country: country,
                offers: os
            });
        }
    });
    await Promise.all(append_offers);
    return new TVOrMovie(search, short_description, seasons, backdrop_url, offers);
}
export class Provider {
    constructor(id, short_name, clear_name, icon_uri, monetization_types) {
        this.id = id;
        this.short_name = short_name;
        this.clear_name = clear_name;
        this.icon_uri = icon_uri;
        this.monetization_types = monetization_types;
    }
}
export async function distilled_providers() {
    var p = await get_all_providers();
    var providers = [];
    var extract_country = p.map(async (i) => {
        let provs = [];
        i["providers"].forEach((i) => {
            if (i["monetization_types"] == null) {
                console.log("Could not add as i[\"monetization_types\"] is null.");
                console.log(i);
            }
            else if (i["monetization_types"].includes("flatrate") || i["monetization_types"].includes("free") || i["monetization_types"].includes("ads")) {
                var monetization_types = i["monetization_types"];
                let regex = new RegExp("\\s*([0-9]+)");
                var regex_match = regex.exec(i["icon_url"]);
                let icon_uri = (regex_match != null) ? `https://www.justwatch.com/images/icon/${regex_match[0]}/s100/icon.webp` : "NULL";
                providers.push(new Provider(i["id"], i["short_name"], i["clear_name"], icon_uri, monetization_types));
            }
        });
    });
    await Promise.all(extract_country);
    const unique = [...new Map(providers.map((item) => [item["id"], item])).values()];
    return unique;
}
